import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { loadJiraData } from 'Shared/actions/user';

export const useJiraData = () => {
  const dispatch = useDispatch();
  const jiraData = useSelector(state => state.user.jiraData);

  useEffect(() => {
    if (!jiraData) {
      dispatch(loadJiraData());
    }
  }, [jiraData, dispatch]);

  return jiraData;
};
